<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";

export default {
  page: {
    title: "Audit Trail",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Audit Trail",
      items: [
        {
          text: "Home",
        },
         {
          text: "User Management",
        },
        {
          text: "Audit Trail",
          active: true,
        },
      ],
    };
  },
  components: {
    Layout,
    PageHeader,
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  </Layout>
</template>